import axios from "api/axios";

// App Backend
export const getAllStripeProducts = async () => {
  const response = await axios.get("/api/stripe/product-list");
  return response.data;
};

export const createPaymentIntent = async (payload) => {
  const response = await axios.post(
    "/api/stripe/create-payment-intent",
    payload
  );
  return response.data;
};

export const createCheckoutSession = async (payload) => {
  const response = await axios.post(
    "/api/stripe/create-checkout-session",
    payload
  );
  return response.data;
};

export const cancelSubscription = async () => {
  const response = await axios.post(
    "/api/stripe/cancel-subscription",
  );
  return response.data;
};

